import React from "react"
import { useDataCatalogModel } from "../dataCatalogModel"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import useMdmModel from "../../../../model/mdmModel"



export function SearchForm() {
    const { mdmCatalog, mdmBranch } = useMdmModel();

    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useDataCatalogModel();
    const searchFields = [
        // {
        //     type: SearchTypeEnum.Select,
        //     span: 4,
        //     placeholder: "分支编码",
        //     fieldName: "defaultBranchCode",
        //     size: "small",
        //     disabled: false,
        //     options: mdmBranch
        // },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "目录名称",
            fieldName: "tableName",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "目录编码",
            fieldName: "code",
            size: "small",
            disabled: false,
        }
    ]
    return (
        <YhPageHeader
            title="目录列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}